var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBsIsEmpty({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2453 7.66406H7.57807C7.23602 7.66406 6.95898 7.9411 6.95898 8.28315V16.9503C6.95898 17.2924 7.23602 17.5694 7.57807 17.5694H16.2453C16.5873 17.5694 16.8643 17.2924 16.8643 16.9503V8.28315C16.8643 7.9411 16.5873 7.66406 16.2453 7.66406ZM15.6262 14.474H13.7689V15.7122H10.0544V14.474H8.19715V8.90223H15.6262V14.474Z",
    fill: "#FFBA0A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5305 10.1401H11.2924V11.9974H10.0542L11.9115 13.8546L13.7687 11.9974H12.5305V10.1401Z",
    fill: "#FFBA0A"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.9118,
    cy: 12.6169,
    r: 11.3864,
    stroke: "#FFBB0A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBsIsEmpty);
export default __webpack_public_path__ + "static/media/bs-is-empty.ee615207620e6e24df756388c88320f7.svg";
export { ForwardRef as ReactComponent };